// extracted by mini-css-extract-plugin
export default {"searchInput":"GosContractGrid_searchInput__P0qX-","gridWrapper":"GosContractGrid_gridWrapper__VbTZw"};